<template>
  <div>
    Hi!
  </div>
</template>

<script>
export default {
  name: "PedidoEnviado"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Paginas/PedidoEnviado.vue